{
  "app": {
    "notification": "通知",
    "next": "下一条",
    "login": {
      "title": "RDA 会员登录",
      "email": "电子邮件",
      "emailRequired": "电子邮件是必填的。",
      "emailValidate": "不是一个可用的电子邮件地址。",
      "password": "密码",
      "passwordRequired": "密码是必填的。",
      "button": "登录",
      "showPassword": "显示密码",
      "registerTip": "还不是会员？",
      "registerLink": "立即注册。",
      "forgotPassword": "忘记密码？"
    },
    "forgotPassword": {
      "title": "重置密码",
      "forgotYourPassword": "忘记密码？",
      "email": "电子邮件地址",
      "emailRequired": "电子邮件是必填的",
      "emailValidate": "无效的电子邮件地址",
      "sendCode": "发送验证码",
      "backToLogin": "返回登录",
      "codeSentMessage": "验证码已发送到您的电子邮件地址。请输入验证码以继续。",
      "cannotReceiveCode": "无法收到验证码？",
      "verificationCode": "验证码",
      "codeRequired": "验证码是必填的",
      "newPassword": "新密码",
      "passwordRequired": "密码是必填的",
      "passwordMinLength": "密码必须至少6个字符",
      "confirmPassword": "确认新密码",
      "confirmPasswordRequired": "请填写",
      "passwordsDoNotMatch": "密码不匹配",
      "showPassword": "显示密码",
      "resetPassword": "确认",
      "codeSent": "验证码已发送到您的电子邮件。",
      "passwordUpdatedSuccessfully": "密码已成功更新。",
      "back": "返回"
    },
    "navbar": {
      "schedule": "日程",
      "availability": "课堂报名",
      "leaveRequest": "请假",
      "accountSetting": "账户设置",
      "classDetails": "课程详情",
      "riderDetails": "骑生详情",
      "volunteerAttendance": "义工出席",
      "riderPairing": "骑生配对",
      "logout": "登出"
    },
    "schedule": {
      "upcomingClass": "即将开课",
      "week": {
        "0": "星期日",
        "1": "星期一",
        "2": "星期二",
        "3": "星期三",
        "4": "星期四",
        "5": "星期五",
        "6": "星期六"
      },
      "noClass": "没有课堂"
    },
    "details": {
      "gender": "性别",
      "male": "男",
      "female": "女",
      "dateOfBirth": "出生日期",
      "age": "年龄",
      "yearsOld": " 岁",
      "height": "身高",
      "weight": "体重",
      "headSize": "头围",
      "school": "学校",
      "disability": "残疾",
      "physicalAbility": "身体能力",
      "walk": "行走",
      "medication": "药物",
      "previousRidingExperience": "骑马经验",
      "others": "其他",
      "volunteerAssigned": "指定义工",
      "assignedTask": "分配任务",
      "equipmentAssigned": "指定装备",
      "horseAssigned": "指定马匹",
      "unitRiders": "骑生",
      "riders": "骑生",
      "yes": "是",
      "no": "否",
      "agreeTakePhoto": "同意拍照",
      "disagreeTakePhoto": "不同意拍照",
      "confirmVolunteersAttendance": "确认义工出席情况",
      "pairHorseEquipmentVolunteerWithRider": "将马匹、装备、义工与骑手配对",
      "undefined": "未定义",
      "noDisability": "无残疾",
      "noMedication": "无药物",
      "noExperience": "无经验",
      "leader": "领队",
      "sideHelper": "辅助者",
      "notAssigned": "未分配"
    },
    "availability": {
      "days": "周",
      "time": "时间",
      "yourSelections": "您的选择",
      "submit": "提交",
      "am": "上午",
      "pm": "下午",
      "noAnyRecords": "没有记录",
      "timeslotUpdateSuccessfully": "首选时段已更新"
    },
    "class": {
      "termRide": "恒常课堂",
      "independentRide": "独立骑生课堂",
      "groupRide": "一日骑马乐"
    },
    "disability": {
      "autismSpectrumDisorders": "自闭症",
      "attentionDeficitAndHyperactivityDisorder": "注意力不集中及多动",
      "specificLearningDifficulties": "读写困难",
      "intellectualDisability": "智力障碍",
      "communicationDifficulties": "沟通困难",
      "visualImpairment": "视觉受损",
      "hearingImpairment": "听力受损",
      "behavioralAndEmotionalDifficulties": "情绪及行为问题",
      "physicalDisability": "肢体伤残",
      "others": "其他"
    },
    "mobility": {
      "independent": "独立",
      "assistanceNeeded": "需协助",
      "unaided": "行动自如",
      "crutches": "拐杖",
      "walkingStick": "手杖",
      "walker": "助步车",
      "wheelchair": "轮椅",
      "others": "其他"
    },
    "leaveRequest": {
      "all": "全部",
      "pending": "待审批",
      "approved": "已记录",
      "appliedDate": "申请日期",
      "type": "类型",
      "leaveType": {
        "sick": "病假",
        "casual": "事假"
      },
      "newLeaveRequest": "新的请假申请",
      "pleaseSelectYourClass": "请选择您的课堂",
      "noAnyRecords": "没有记录",
      "submit": "提交",
      "leaveRequestAddedSuccessfully": "请假请求已添加"
    },
    "accountSetting": {
      "updatePassword": "更新密码",
      "currentPassword": "当前密码",
      "newPassword": "新密码",
      "confirmPassword": "确认密码",
      "showPassword": "显示密码",
      "submit": "提交",
      "cancel": "取消",
      "passwordRequired": "密码是必填项。",
      "passwordNotMatch": "密码不匹配。",
      "passwordAtLeast6Char": "密码至少6个字符。",
      "pleaseFill": "请填写",
      "passwordUpdateSuccessfully": "密码已成功修改",
      "originPasswordIncorrect": "原本密码不正确"
    },
    "assessment": {
      "assessment": "评估",
      "communication": "沟通",
      "select": "选择",
      "confident": "自信",
      "enjoyment": "乐趣",
      "horsemanship": "骑马技巧",
      "physicalChange": "身体变化",
      "submit": "提交",
      "assessmentUpdateSuccessfully": "评估已更新"
    },
    "volunteerAttendance": {
      "name": "姓名",
      "attendance": "出席",
      "confirm": "确认",
      "yes": "是",
      "no": "否",
      "noVolunteer": "无义工",
      "attendanceUpdateSuccessfully": "义工签到状态已更新"
    },
    "riderPairing": {
      "volunteer": "义工",
      "selectVolunteer": "选择义工",
      "leader": "领队",
      "sideHelper": "辅助员",
      "submit": "提交",
      "equipment": "装备",
      "selectEquipment": "选择装备",
      "horse": "马匹",
      "selectHorse": "选择马匹",
      "pairingUpdateSuccessfully": "配对已更新"
    },
    "errorMsg": {
      "Current password is incorrect": "原本密码不正确",
      "The new password must be at least 8 characters.": "新密码必须至少为8个字符"
    },
    "register": {
      "register": "注册",
      "seeTheDateTime": "查看日期和时间",
      "tuenMunPublicRidingSchool": "屯门骑术学校",
      "tuenMunPublicRidingSchoolAddress": "新界屯门龙门路四十五号地段",
      "beasRiverEquestrianCentre": "双鱼河马术事务中心",
      "beasRiverEquestrianCentreAddress": "新界上水94约922地段乡村会所",
      "leiYueMunPublicRidingSchool": "鲤鱼门骑术学校",
      "leiYueMunPublicRidingSchoolAddress": "柴湾峡柴湾道75号",
      "monToFri": "周一至周五",
      "part": "部分",
      "sat": "周六",
      "wedAndFri": "周三及周五",
      "tueAndThu": "周二及周四",
      "am": "上午",
      "pm": "下午",
      "back": "上一步",
      "next": "下一步",
      "yes": "是",
      "no": "否",
      "confirm": "确认",
      "pleaseEnter": "请输入。",
      "pleaseSelect": "请选择。",
      "email": "电子邮件",
      "password": "密码",
      "confirmPassword": "确认密码",
      "showPassword": "显示密码",
      "englishName": "英文姓名",
      "chineseName": "中文姓名",
      "gender": "性别",
      "male": "男",
      "female": "女",
      "dateOfBirth": "出生日期",
      "idCardNo": "身份证号码",
      "phoneNumber": "电话号码",
      "occupation": "职业",
      "address": "地址",
      "registerSuccessfully": "注册成功",
      "fullName": "姓名",
      "relationship": "关系",
      "expRFD": "残疾人士骑术经验",
      "RHExp": "骑术/马术经验",
      "medExp": "医疗经验",
      "knowAndExp": {
        "label": "知识和经验",
        "pvMaking": "摄影/视频制作",
        "workWithChild": "与儿童工作",
        "workWithPD": "与残疾人士工作",
        "media": "媒体"
      },
      "howDidFind": {
        "label": "您是如何得知RDA香港的？",
        "rdaHKWebsite": "RDA香港网站",
        "rdaFacebook": "RDA Facebook",
        "searchEngine": "搜索引擎",
        "friends": "朋友",
        "others": "其他（请说明）"
      },
      "contactNumber": "联系电话",
      "relWithReferer": "与推荐人关系",
      "declaration1": "本人谨此声明，在香港伤健策骑协会有限公司习骑活动担任义工所遇到的一切风险，将由本人自行承担，并同意对本人的言行负责。",
      "declaration2": "本人愿意在香港伤健策骑协会有限公司习骑活动担任义工时遵守儿童及脆弱成人保障政策以及义工工作指引。",
      "iAgreeTo": "我同意",
      "consentCVASP": "RDA儿童及易受伤害成年人保障政策",
      "consentRaR": "RDA规章制度",
      "consentVWG": "义工工作指南",
      "consentIF2016": "RDA豁免责任表格2016",
      "personalInformation": "个人资料",
      "emergencyContact": "紧急联络人",
      "locationPreference": "地点偏好",
      "locationPreferenceTip": "选择您偏好的地点（可选择多个地点）",
      "knowledgeExperience": "知识和经验",
      "knowledgeExperienceTip": "以下信息有助于我们充分利用您的知识和经验。请告诉我们您想要参与什么工作！",
      "volunteerReferralScheme": "RDA义工推荐计划（如适用）",
      "declarationConsent": "声明和同意",
      "declarationTip": "请勾选以下内容以确认您的申请",
      "consentTip": "请勾选以下内容以表明您的同意"
    }
  },
  "consentCVASP": "RDA儿童及易受伤害成年人保障政策",
  "consentRaR": "RDA规章制度",
  "consentVWG": "义工工作指南",
  "consentIF2016": "RDA豁免责任表格2016"
}
